import actionTypes from '../../actions/actionTypes'
import { fromJS } from 'immutable'
import { returnStateIfNoAction } from '../helpers'
import { PROGRAM_DEFAULT } from '../../constants/state'
import { addItem, updateItem, deleteItem } from './helpers'


const INIT_STATE = fromJS(PROGRAM_DEFAULT.ads)


const adsReducer = (state = INIT_STATE, action) => {
    
    returnStateIfNoAction(action, state)

    switch(action.type){
        case actionTypes.ADS_ADD_ITEM:
            return addItem(state, action);
        case actionTypes.ADS_UPDATE_ITEM:
            return updateItem(state, action);
        case actionTypes.ADS_DELETE_ITEM:
            return deleteItem(state, action);
        default:
            return state;
    }
}

export default adsReducer